import React, { useRef, useState } from "react";
import styles from "./PhaseDropdown.module.css";
import { DropDown, IconComponent, icon } from "../../index";

interface Phase {
	id: string | number;
	name: string;
}

interface PhaseDropdownProps {
	selectedSourcePhaseId: string | number | null;
	setSelectedSourcePhaseId: (id: string | number) => void;
	phases: Phase[];
	phase?: Phase | null;
	translate: (key: string) => string;
}

const PhaseDropdown = ({
	selectedSourcePhaseId,
	setSelectedSourcePhaseId,
	phases,
	phase,
	translate,
}: PhaseDropdownProps) => {
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);

	const handleToggle = () => {
		setOpen((prev) => !prev);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSelect = (id: string | number) => {
		setSelectedSourcePhaseId(id);
		setOpen(false);
	};

	return (
		<div className={styles.dropdownWrapper}>
			<div
				ref={anchorRef}
				className={styles.phaseSelect}
				role="button"
				tabIndex={0}
				onClick={handleToggle}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						handleToggle();
					}
				}}
			>
				<span className={styles.phaseSelectLabel}>
					{selectedSourcePhaseId
						? phases.find((p) => p.id === selectedSourcePhaseId)?.name
						: translate("common:select.phase")}
				</span>
				<IconComponent className={styles.phaseSelectArrow} icon={icon.faChevronDown} />
			</div>

			<DropDown ref={anchorRef} open={open} position="bottom-start" onClose={handleClose}>
				<div className={styles.menuList}>
					{phases
						.filter((p) => p.id !== phase?.id)
						.map((p) => (
							<div
								key={p.id}
								className={styles.menuItem}
								role="button"
								tabIndex={0}
								onClick={() => handleSelect(p.id)}
								onKeyDown={(e) => {
									if (e.key === "Enter" || e.key === " ") {
										handleSelect(p.id);
									}
								}}
							>
								{p.name}
							</div>
						))}
				</div>
			</DropDown>
		</div>
	);
};

export default PhaseDropdown;
